import { JsonServiceClient } from "@servicestack/client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as DTOS from "../FeralScan.dtos";
import { FilterState } from "../reducers/filter.reducer";


export const serviceApi = {
    createPlot: (plot: DTOS.Plot) => {
        var client = new JsonServiceClient("");
        var createRequest = new DTOS.CreatePlot();

        createRequest.plot = plot;

        const promise = client.post(createRequest);
        return Observable.from(promise);
    },

    updatePlot: (plot: DTOS.Plot) => {
        var client = new JsonServiceClient("");
        var updateRequest = new DTOS.UpdatePlot();

        updateRequest.plot = plot;
        updateRequest.plotId = plot.id;

        const promise = client.put(updateRequest);
        return Observable.from(promise);
    },

    deletePlotEvent: (plotEventId: number) => {
        var client = new JsonServiceClient("");
        var deleteRequest = new DTOS.DeletePlotEvent();
        deleteRequest.plotEventId = plotEventId;
        const promise = client.delete(deleteRequest);
        return Observable.from(promise);
    },

    flagPlot: (plot: DTOS.Plot) => {
        var client = new JsonServiceClient("");
        var saveRequest = new DTOS.FlagPlot();
        saveRequest.plot = plot;
        const promise = client.put(saveRequest);
        return Observable.from(promise);
    },

    save: (userPreference: DTOS.UserPreference, filters: FilterState) => {
        var client = new JsonServiceClient("");
        var saveRequest = new DTOS.SaveFilter();

        if (filters != undefined) {
            saveRequest.filters = JSON.stringify(filters);
        }

        saveRequest.preferences = userPreference;
        saveRequest.product = process.env.PRODUCT;
        const promise = client.put(saveRequest);
        return Observable.from(promise);
    },

    report: (searchFilter: FilterState) => {
        var client = new JsonServiceClient("");
        var searchRequest = new DTOS.Report();
        if (searchFilter !== undefined) {
            searchRequest.startDate = searchFilter.startDate;
            searchRequest.endDate = searchFilter.endDate;
            //searchRequest.classifications = searchFilter.selectedClassifications ? searchFilter.selectedClassifications.concat(searchFilter.selectedTypes) : undefined;
            searchRequest.groups = searchFilter.selectedGroups;
            searchRequest.questions = searchFilter.selectedQuestions;
            searchRequest.regions = searchFilter.selectedRegion;
        }
        searchRequest.product = process.env.PRODUCT;
        const promise = client.put(searchRequest);
        return Observable.from(promise);
    },

    getReferenceData: () => {
        var client = new JsonServiceClient("");
        var request = new DTOS.GetReferenceData();

        request.product = process.env.PRODUCT;
        const promise = client.get(request);
        return Observable.from(promise);
    },

    getQuestionReferenceData: (classifications: DTOS.QuestionOption[]) => {
        var client = new JsonServiceClient("");
        var request = new DTOS.GetQuestionReferenceData();
        request.parentOptions = classifications;
        request.product = process.env.PRODUCT;
        const promise = client.put(request);
        return Observable.from(promise);
    },

    submitSurvey: (survey: DTOS.Survey) => {
        var client = new JsonServiceClient("");
        var request = new DTOS.SaveSurvey();
        request.product = process.env.PRODUCT;
        request.survey = survey;
        const promise = client.post(request);
        return Observable.from(promise);
    },

    getEventQuestions: (speciesId: number, eventTypeId: number) => {
        var client = new JsonServiceClient("");
        var request = new DTOS.GetSurvey();
        request.speciesId = speciesId;
        request.eventTypeId = eventTypeId;
        request.product = process.env.PRODUCT;
        const promise = client.get(request);
        return Observable.from(promise);
    },
    uploadPlotPhotos: (files: File[], plotId: number) => {
        var client = new JsonServiceClient("");
        var request = new DTOS.UploadPlotPhotos();

        let formData = new FormData();
        files.forEach(file => {
            formData.append('description', file.name);
            formData.append('type', 'file');
            formData.append('file', file);
        });

        formData.append('plotId', plotId.toString());

        const promise = client.postBody(request, formData);
        return Observable.from(promise);
    }
};
